<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader.vue";
import CreateStok from "./create_stock.vue"
import DetailStock from "./detail_stock.vue"
import Transfer from "./transfer.vue"
import History from "./history.vue"

export default {
    page: {
        title: "Stok Yönetimi",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    components: {
        Layout,
        PageHeader,
        Loader,
        CreateStok,
        Transfer,
        History,
        DetailStock
    },
    data() {
        return {
            list: {},
            title: "DEPO STOK LİSTESİ",
            items: [
                {
                    text: "ANASAYFA",
                    href: "/",
                },
                {
                    text: "DEPO STOK LİSTESİ",
                    active: true,
                },
            ],
            collapses: [],
            isLoading: false,
            rows: [],
            arizali: [],
            arizaForm: { key: '', amount: 1, barcode: '' },
            searchQuery: '',
            transferModal:0,
            historyModal:0,
            transferData:{amount:0},
            historyData:{},
            openModal: 0,
            detailModal:0,
            detailData: {},
            userdata:null
        };
    },
    computed: {
        filteredRows() {
            const query = (this.searchQuery || '').trim().toLowerCase();
            if (!query) return this.rows;

            return this.rows.reduce((list, row) => {
                const depotMatch = (row.user_name || '').toLowerCase().includes(query);
                const stocks = depotMatch
                    ? row.stocks
                    : row.stocks.filter(stock => this.stockMatches(stock, query));

                if (stocks.length) {
                    list.push({ ...row, stocks });
                }
                return list;
            }, []);
        },
        stats() {
            const types = new Set();
            let lines = 0;

            this.rows.forEach(row => {
                (row.stocks || []).forEach(stock => {
                    types.add(stock.stock_group_id);
                    lines += 1;
                });
            });

            return {
                depots: this.rows.length,
                types: types.size,
                lines
            };
        },
        arizaSecenekleri() {
            const list = []
            this.rows.forEach(row => {
                (row.stocks || []).forEach(stock => {
                    list.push({
                        key: row.user_id + '-' + stock.stock_group_id,
                        label: row.user_name + ' / ' + stock.stock_group_name,
                        user_id: row.user_id,
                        stock_group_id: stock.stock_group_id,
                        sarf: ['sm', 'ka', 'si'].includes(stock.group_id),
                        unit: stock.unit || 'adet',
                        barcodes: stock.barcodes || []
                    })
                })
            })
            return list
        },
        arizaSecilen() {
            return this.arizaSecenekleri.find(e => e.key === this.arizaForm.key) || null
        },
        emptyText() {
            return this.searchQuery.trim()
                ? 'Aramanızla eşleşen stok bulunamadı'
                : 'Henüz depo stoğu bulunmuyor';
        },
        productTotals() {
            const map = {};

            this.filteredRows.forEach(row => {
                (row.stocks || []).forEach(stock => {
                    const key = stock.stock_group_id || stock.stock_group_name;
                    if (!map[key]) {
                        map[key] = {
                            name: stock.stock_group_name,
                            unit: stock.unit || 'adet',
                            amount: 0
                        };
                    }
                    map[key].amount += Number(stock.amount) || 0;
                });
            });

            return Object.values(map)
                .map(item => ({ ...item, amount: this.formatQty(item.amount) }))
                .sort((a, b) => String(a.name).localeCompare(String(b.name), 'tr'));
        }
    },
    watch: {
        searchQuery() {
            this.$nextTick(() => this.updateCollapseState());
        }
    },
    mounted() {
        this.loadItems()
        this.loadArizali()
        this.userdata = JSON.parse(localStorage.getItem('userdata'))
    },
    methods: {
        loadArizali() {
            this.$http.get('/stock/depo/arizali').then(res => {
                this.arizali = res.data || []
            }).catch(() => { this.arizali = [] })
        },
        openAriza() {
            this.arizaForm = { key: '', amount: 1, barcode: '' }
            this.$parent.$bvModal.show('arizali-urun')
        },
        arizaKaydet() {
            const secilen = this.arizaSecenekleri.find(e => e.key === this.arizaForm.key)
            if (!secilen) return
            const payload = { user_id: secilen.user_id, stock_group_id: secilen.stock_group_id }
            if (secilen.sarf) payload.amount = this.arizaForm.amount
            else payload.barcode = this.arizaForm.barcode
            this.$http.post('/stock/depo/arizaya-al', payload).then(() => {
                this.$parent.$bvModal.hide('arizali-urun')
                this.loadItems()
            }).catch(err => {
                window.alert((err.response && err.response.data && err.response.data.message) || 'Alınamadı')
            })
        },
        loadItems() {
            this.isLoading = true
            this.loadArizali()
            this.$http.post('/stock/depo', this.serverParams)
                .then(response => {
                    const groupedData = {};
                    response.data.forEach(item => {
                        if (!groupedData[item.user_name]) {
                            groupedData[item.user_name] = {
                                    user_name: item.user_id == 1 ? 'Ana Depo' : item.user_name,
                                    user_id: item.user_id,
                                    class: item.user_id == 1 ? 'primary' : 'secondary',
                                    stocks: []
                                }
                        }
                        groupedData[item.user_name].stocks.push({
                            stock_group_name: item.stock_group_name,
                            amount: item.amount,
                            unit: item.unit,
                            stock_group_id: item.stock_group_id,
                            group_id: item.group_id,
                            barcodes: (item.barcodes || '').split('|').map(code => code.trim()).filter(Boolean)
                        });
                    });
                    this.rows = Object.values(groupedData);
                    this.updateCollapseState();
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
        updateCollapseState() {
            this.collapses = this.filteredRows.map((_, index) => index);
        },
        formatQty(value) {
            const n = Number(value);
            if (Number.isNaN(n)) return value || 0;
            return Number.isInteger(n) ? n : parseFloat(n.toFixed(2));
        },
        stockMatches(stock, query) {
            if ((stock.stock_group_name || '').toLowerCase().includes(query)) {
                return true;
            }
            return (stock.barcodes || []).some(code => code.toLowerCase().includes(query));
        },
        matchedBarcodes(stock) {
            const query = (this.searchQuery || '').trim().toLowerCase();
            if (!query) return [];
            return (stock.barcodes || []).filter(code => code.toLowerCase().includes(query));
        },
        create(){
            this.list = {}
            this.openModal += 1
            this.$parent.$bvModal.show('modal-scoped')
        },
        openTransferModal() {
            this.transferModal +=1
            this.transferData = { stoktipi: 'depo' }
            this.$parent.$bvModal.show('transfer')
        },
        openHistoryModal(user_id, stock_group_id){
            this.historyModal +=1
            this.historyData = { user_id, stock_group_id }
            this.$parent.$bvModal.show('history')
        },
        collapseEvent(idx) {
            if (this.collapses.includes(idx)) {
                const index = this.collapses.indexOf(idx);
                if (index > -1) {
                    this.collapses.splice(index, 1);
                }
            } else {
                this.collapses.push(idx)
            }
        },
        detail({stock_group_id},{user_id}) {
            this.detailModal +=1
            this.detailData = {stock_group_id,user_id}
            this.$parent.$bvModal.show('detail_stock')
        },
        qtyClass(amount) {
            return Number(amount) <= 0 ? 'is-empty' : 'is-ok';
        },
        initials(name) {
            return (name || '?').charAt(0).toUpperCase();
        },
        excelExport() {
            const currentDate = new Date();
            const filename = `${currentDate.getFullYear()}${('0' + (currentDate.getMonth() + 1)).slice(-2)}${('0' + currentDate.getDate()).slice(-2)}${('0' + currentDate.getHours()).slice(-2)}${('0' + currentDate.getMinutes()).slice(-2)}${('0' + currentDate.getSeconds()).slice(-2)}_DEPO_STOK.xlsx`;

            this.$http.post('/stock/depo?excel=true', {}, { responseType: 'blob' })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    link.setAttribute('type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });
        }
    },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <DetailStock :data="detailData" :openModal='detailModal' @loadItems="loadItems" />
    <CreateStok :data="openModal" @loadItems="loadItems" />
    <Transfer :openModal='transferModal' :data="transferData" @loadItems="loadItems" />
    <History :openModal='historyModal' :data="historyData" />

    <b-modal id="arizali-urun" title="Arızalı Ürün" hide-footer>
        <div class="mb-3">
            <label>Ürün</label>
            <select class="form-control" v-model="arizaForm.key">
                <option value="">Seçin</option>
                <option v-for="item in arizaSecenekleri" :key="item.key" :value="item.key">{{ item.label }}</option>
            </select>
        </div>
        <div class="mb-3" v-if="arizaSecilen && arizaSecilen.sarf">
            <label>Miktar ({{ arizaSecilen.unit }})</label>
            <input type="number" min="0.01" step="0.01" class="form-control" v-model="arizaForm.amount">
        </div>
        <div class="mb-3" v-else-if="arizaSecilen">
            <label>Barkod</label>
            <select class="form-control" v-model="arizaForm.barcode">
                <option value="">Seçin</option>
                <option v-for="code in arizaSecilen.barcodes" :key="code" :value="code">{{ code }}</option>
            </select>
        </div>
        <button type="button" class="btn btn-danger" :disabled="!arizaForm.key" @click="arizaKaydet">Arızalıya al</button>
    </b-modal>

    <div class="depo-page">
        <div class="depo-toolbar">
            <div class="depo-toolbar__info">
                <p class="depo-toolbar__eyebrow">Stok Yönetimi</p>
                <h4 class="depo-toolbar__title">Depo Stokları</h4>
            </div>

            <div class="depo-search">
                <i class="bx bx-search depo-search__icon"></i>
                <input
                    type="text"
                    class="depo-search__input"
                    v-model="searchQuery"
                    placeholder="Depo, ürün veya barkod ara..."
                />
            </div>

            <div class="depo-toolbar__actions">
                <button type="button" class="depo-btn depo-btn--excel" @click="excelExport">
                    <i class="bx bx-export"></i>
                    Excel'e Al
                </button>

                <template v-if="userdata && userdata.role_name == 'admin'">
                    <button type="button" class="depo-btn depo-btn--dark" @click="openAriza">
                        <i class="bx bx-error"></i>
                        Arızalı Ürün
                    </button>
                    <button type="button" class="depo-btn depo-btn--success" @click="create">
                        <i class="bx bx-plus"></i>
                        Yeni Ürün
                    </button>
                    <button type="button" class="depo-btn depo-btn--dark" @click="openTransferModal()">
                        <i class="bx bx-transfer-alt"></i>
                        Transfer Et
                    </button>
                </template>
            </div>
        </div>

        <div class="depo-stats">
            <div class="depo-stat">
                <span class="depo-stat__icon depo-stat__icon--blue"><i class="bx bx-buildings"></i></span>
                <div>
                    <span class="depo-stat__label">Depo</span>
                    <strong class="depo-stat__value">{{ stats.depots }}</strong>
                </div>
            </div>
            <div class="depo-stat">
                <span class="depo-stat__icon depo-stat__icon--violet"><i class="bx bx-package"></i></span>
                <div>
                    <span class="depo-stat__label">Ürün Çeşidi</span>
                    <strong class="depo-stat__value">{{ stats.types }}</strong>
                </div>
            </div>
            <div class="depo-stat">
                <span class="depo-stat__icon depo-stat__icon--green"><i class="bx bx-box"></i></span>
                <div>
                    <span class="depo-stat__label">Stok Satırı</span>
                    <strong class="depo-stat__value">{{ stats.lines }}</strong>
                </div>
            </div>
        </div>

        <Loader :loading="true" :load="isLoading">
            <div v-if="!filteredRows.length" class="depo-empty">
                <i class="bx bx-package"></i>
                <p>{{ emptyText }}</p>
            </div>

            <div v-else class="row">
                <div
                    v-for="(row, i) in filteredRows"
                    :key="row.user_id + '-' + i"
                    class="col-12 mb-3"
                >
                    <div
                        class="depo-card"
                        :class="{
                            'is-open': collapses.includes(i),
                            'is-main': row.user_id == 1
                        }"
                    >
                        <button type="button" class="depo-card__head" @click="collapseEvent(i)">
                            <span class="depo-card__avatar">{{ initials(row.user_name) }}</span>
                            <div class="depo-card__meta">
                                <strong>{{ row.user_name }}</strong>
                                <small>{{ row.stocks.length }} ürün</small>
                            </div>
                            <span class="depo-card__badge" v-if="row.user_id == 1">Ana</span>
                            <i class="bx depo-card__chevron" :class="collapses.includes(i) ? 'bx-chevron-up' : 'bx-chevron-down'"></i>
                        </button>

                        <div class="depo-card__body" v-show="collapses.includes(i)">
                            <div
                                v-for="(stock, b) in row.stocks"
                                :key="row.user_id + '-' + b"
                                class="depo-item"
                            >
                                <button type="button" class="depo-item__name" @click="detail(stock, row)">
                                    {{ stock.stock_group_name }}
                                    <small v-if="matchedBarcodes(stock).length" class="depo-item__barcode">
                                        {{ matchedBarcodes(stock).join(', ') }}
                                    </small>
                                </button>
                                <span class="depo-item__qty" :class="qtyClass(stock.amount)">
                                    <b>{{ formatQty(stock.amount) }}</b>
                                    <small>{{ stock.unit }}</small>
                                </span>
                                <button
                                    type="button"
                                    class="depo-item__history"
                                    @click.stop="openHistoryModal(row.user_id, stock.stock_group_id)"
                                >
                                    <i class="bx bx-history"></i>
                                    Hareketler
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="depo-totals">
                <div class="depo-totals__head">
                    <h5>Arızalı Ürünler</h5>
                    <small>{{ arizali.length }} kayıt</small>
                </div>
                <div v-if="!arizali.length" class="text-muted px-3 pb-3">Arızalı stok yok</div>
                <table v-else class="table mb-0">
                    <thead>
                        <tr><th>Depo</th><th>Ürün</th><th>Seri / Ad</th><th>Miktar</th><th>Tarih</th></tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in arizali" :key="item.id">
                            <td>{{ item.depot }}</td>
                            <td>{{ item.product }}</td>
                            <td>{{ item.name || '-' }}</td>
                            <td>{{ item.amount }} {{ item.unit }}</td>
                            <td>{{ (item.updated_at || '').slice(0, 16) }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="depo-totals" v-if="productTotals.length">
                <div class="depo-totals__head">
                    <h5>Genel Toplam</h5>
                    <small>{{ productTotals.length }} ürün</small>
                </div>
                <table class="table mb-0 depo-totals__table">
                    <thead>
                        <tr><th>Ürün</th><th class="text-end">Miktar</th></tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in productTotals" :key="item.name + '-' + item.unit">
                            <td>{{ item.name }}</td>
                            <td class="text-end"><strong>{{ item.amount }}</strong> <small>{{ item.unit }}</small></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Loader>
    </div>
  </Layout>
</template>

<style scoped>
.depo-page {
    display: flex;
    flex-direction: column;
    gap: 18px;
}
.depo-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 18px 20px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}
.depo-toolbar__eyebrow {
    margin: 0 0 2px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #2563eb;
}
.depo-toolbar__title {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 700;
    color: #0f172a;
}
.depo-search {
    position: relative;
    flex: 1;
    min-width: 220px;
    max-width: 360px;
}
.depo-search__icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 18px;
    pointer-events: none;
}
.depo-search__input {
    width: 100%;
    height: 42px;
    padding: 0 14px 0 38px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    background: #f8fafc;
    color: #0f172a;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
}
.depo-search__input:focus {
    border-color: #2563eb;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}
.depo-toolbar__actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}
.depo-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 42px;
    padding: 0 14px;
    border: none;
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.15s, box-shadow 0.15s;
}
.depo-btn:hover {
    transform: translateY(-1px);
}
.depo-btn--success {
    background: linear-gradient(135deg, #16a34a, #15803d);
    color: #fff;
    box-shadow: 0 6px 16px rgba(22, 163, 74, 0.22);
}
.depo-btn--dark {
    background: #0f172a;
    color: #fff;
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.18);
}
.depo-btn--excel {
    background: #f0fdf4;
    color: #059669;
    border: 1px solid #bbf7d0;
    box-shadow: none;
}
.depo-stats {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px;
}
.depo-stat {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 14px;
    padding: 16px 18px;
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
}
.depo-stat__icon {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    flex-shrink: 0;
}
.depo-stat__icon--blue { background: #eff6ff; color: #2563eb; }
.depo-stat__icon--violet { background: #f5f3ff; color: #7c3aed; }
.depo-stat__icon--green { background: #ecfdf5; color: #059669; }
.depo-stat__label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #64748b;
}
.depo-stat__value {
    display: block;
    font-size: 1.35rem;
    line-height: 1.2;
    color: #0f172a;
}
.depo-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    min-height: 220px;
    background: #fff;
    border: 1px dashed #cbd5e1;
    border-radius: 16px;
    color: #94a3b8;
}
.depo-empty i { font-size: 2.4rem; }
.depo-empty p { margin: 0; font-weight: 600; }
.depo-card {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
    transition: border-color 0.2s, box-shadow 0.2s;
}
.depo-card.is-open {
    border-color: #bfdbfe;
    box-shadow: 0 10px 24px rgba(37, 99, 235, 0.08);
}
.depo-card.is-main.is-open {
    border-color: #93c5fd;
}
.depo-card__head {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border: none;
    background: #f8fafc;
    cursor: pointer;
    text-align: left;
}
.depo-card.is-open .depo-card__head {
    background: #eff6ff;
}
.depo-card.is-main .depo-card__head {
    background: linear-gradient(135deg, #eff6ff, #f8fafc);
}
.depo-card__avatar {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #dbeafe, #bfdbfe);
    color: #1d4ed8;
    font-weight: 700;
    flex-shrink: 0;
}
.depo-card.is-main .depo-card__avatar {
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: #fff;
}
.depo-card__meta {
    min-width: 0;
    flex: 1;
}
.depo-card__meta strong {
    display: block;
    font-size: 14px;
    color: #0f172a;
}
.depo-card__meta small {
    display: block;
    margin-top: 2px;
    color: #94a3b8;
    font-size: 12px;
}
.depo-card__badge {
    padding: 4px 10px;
    border-radius: 999px;
    background: #dbeafe;
    color: #1d4ed8;
    font-size: 11px;
    font-weight: 700;
}
.depo-card__chevron {
    font-size: 20px;
    color: #64748b;
}
.depo-card__body {
    padding: 8px;
    border-top: 1px solid #eef2f7;
}
.depo-totals {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}
.depo-totals__head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    background: #f8fafc;
    border-bottom: 1px solid #eef2f7;
}
.depo-totals__head h5 {
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
}
.depo-totals__head small {
    color: #94a3b8;
    font-weight: 600;
}
.depo-totals__table th {
    font-size: 12px;
    color: #64748b;
    font-weight: 700;
    border-top: 0;
}
.depo-totals__table td {
    font-size: 14px;
    color: #0f172a;
    vertical-align: middle;
}
.depo-totals__table strong { color: #059669; }
.depo-totals__table small { color: #94a3b8; margin-left: 4px; }
.depo-item {
    display: grid;
    grid-template-columns: 1fr auto auto;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border-radius: 10px;
}
.depo-item + .depo-item {
    border-top: 1px dashed #f1f5f9;
}
.depo-item:hover {
    background: #f8fafc;
}
.depo-item__name {
    border: none;
    background: none;
    padding: 0;
    text-align: left;
    color: #0f172a;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}
.depo-item__name:hover {
    color: #2563eb;
}
.depo-item__barcode {
    display: block;
    margin-top: 2px;
    color: #2563eb;
    font-size: 11px;
    font-weight: 600;
}
.depo-item__qty {
    display: inline-flex;
    align-items: baseline;
    gap: 4px;
    min-width: 72px;
    justify-content: flex-end;
    font-size: 14px;
}
.depo-item__qty.is-ok { color: #059669; }
.depo-item__qty.is-empty { color: #dc2626; }
.depo-item__qty small {
    color: #94a3b8;
    font-size: 11px;
    font-weight: 600;
}
.depo-item__history {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 5px 10px;
    border: 1px solid #bfdbfe;
    border-radius: 8px;
    background: #eff6ff;
    color: #2563eb;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
}
.depo-item__history:hover {
    background: #dbeafe;
}
@media (max-width: 991.98px) {
    .depo-search { max-width: none; }
    .depo-stats { grid-template-columns: 1fr; }
}
@media (max-width: 767.98px) {
    .depo-item {
        grid-template-columns: 1fr auto;
        gap: 8px;
    }
    .depo-item__history {
        grid-column: 1 / -1;
        justify-content: center;
    }
}
</style>
